import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-side-bar-not-logged',
  templateUrl: './side-bar-not-logged.component.html',
  styleUrls: ['./side-bar-not-logged.component.css']
})
export class SideBarNotLoggedComponent implements OnInit {

  constructor(
    public app: AppService,
    private router : Router
    ) { }

  ngOnInit(): void {
  }

  routeLogin() {
    if (this.router.url == '/login-page') { return }
    if (this.router.url.includes("doctor-profile")) {
      let x = this.router.url.indexOf("?")
      let b = this.router.url.slice(0, x)
      this.router.navigate(['/' + this?.app?.languageCode + '/login-page'], {
        queryParams: {
          'prevUrl': b,
        }
      });
    } else {
      this.router.navigate(['/' + this?.app?.languageCode + '/login-page'], {
        queryParams: {
          'prevUrl': this.router.url,
        }
      });
    }
  }

}
